import {
  ajaxUniGetAsync,
  ajaxUniPostUsingCaptcha,
  ajaxPlatebniBranaAkaPost,
} from './shared/ajaxutils';
import {
  LoadCourseInstancesForLastLoadedDetailAsync,
  ShowMyCartSummaryAsync,
  MarkCoursesOccupancyAsync,
  MarkMyCoursesAsync,
  // LoadOrderUserInfoAsync,
} from './aka.js';
import { getUrlParameter } from './shared/utils';
import {
  Window,
  FunctionHandler,
  FunctionCallback,
  JsonData,
} from './shared/akatypes';
import {
  confirmCtkButtons,
  alertCtk,
  alertCtkOKFunction,
  fillCountries,
  alertCtkApiError,
} from './shared/utils';
import { getValue, getCheckboxChecked, validateProfilePart } from './validate';

declare const window: Window;
const jQuery = window.jQuery;

export async function mainnakup() {
  // const id = getUrlParameter('id').toString();
  console.log('main nakup '); // + id);
  fillCountries();
  await LoadOrderUserInfoAsync();
  await ShowMyCartSummaryAsync();
  bindHandlers();
}

export function LoadOrderUserInfoAsync(): Promise<boolean> {
  return new Promise((resolve, reject) => {
    const data = {};
    const successFunc = (result: string) => {
      console.log('load OrderUserInfo returned');
      const parsed = JSON.parse(result.trim());
      console.log(parsed);
      const json = { ...parsed };
      // alert('fillorderuserinfo' + JSON.stringify(json)); //fillorderuserinfo
      if (result.trim() !== '{}') {
        fillValuesJson(json);
      } else {
        jQuery('#userinfofilled').html(
          '<b>Když se přihlásíte vpravo nahoře, tak budou údaje předvyplněny</b>',
        );
      }
      // window.lecturers = json.userinfo;
      /*
      jQuery('#lecturersdiv').html(
        '' +
          //json.lecturers.map((it: string) => '<li>' + it + '</li>').join('\n') +
          json.lecturers
            .map((it: any) => '' + GenerateLecturerTile(it) + '')
            .join('\n') +
          '',
      );
      window.lecturers.forEach((it: any) => {
        it.courseids = [];
      });
      */
      resolve(true);
    };
    ajaxUniGetAsync('LoadOrderUserInfo', data, successFunc);
  });
}

// import { ajaxSubmit } from './ajaxindex';

function setValue(name: string, value: string) {
  jQuery('#form' + name).val(value);
}

export function validate() {
  validateProfilePart('all', false);
}
export function validateSilent() {
  validateProfilePart('all', true);
}

export function fillValuesJson(json: any) {
  setValue('company', json.company);
  setValue('name', json.name);
  setValue('surname', json.surname);
  setValue('email', json.email);
  setValue('phone', json.phone);
  setValue('street', json.street);
  setValue('city', json.city);
  setValue('psc', json.psc);
  setValue('country', json.country);
  setValue('ic', json.ic);
  setValue('dic', json.dic);
  setValue('comment', json.comment);
  // jQuery("textarea[name='poznamka']").text = json.comment;
  validate();
}
export function fillEmptyValues() {
  setValue('company', '');
  setValue('name', '');
  setValue('surname', '');
  setValue('email', '');
  setValue('phone', '');
  setValue('street', '');
  setValue('city', '');
  setValue('psc', '');
  setValue('country', 'Česká republika');
  setValue('ic', '');
  setValue('dic', '');
  setValue('comment', '');
  // jQuery("textarea[name='poznamka']").text = json.comment;
  validate();
}

function sendOrder(event: any) {
  console.log('submitting form');
  const f = jQuery('#formsubmit');
  validate();
  if (f.hasClass('notusable')) {
    alertCtk(window.ctkerrormessage);
  } else {
    ajaxSendOrderFinish();
  }
  event.preventDefault();
  return false;
}
function sendOrderBack(event: any) {
  console.log('submitting form back');
  ajaxSubmitBack();
  event.preventDefault();
  return false;
}

export function ajaxSendOrderFinish() {
  const data: any = {};
  data.company = getValue('company');
  data.name = getValue('name');
  data.surname = getValue('surname');
  data.email = getValue('email');
  data.phone = getValue('phone');
  data.street = getValue('street');
  data.city = getValue('city');
  data.psc = getValue('psc');
  data.country = getValue('country');
  data.ic = getValue('ic');
  data.dic = getValue('dic');
  // data.comment = getValue('poznamka');
  data.comment = getValue('comment');
  const successFunc = (result: string) => {
    console.log('save order returned');
    const parsed = JSON.parse(result.trim());
    console.log(parsed);
    const res: any = { ...parsed };

    if (res.status === 'userExists') {
      alertCtk(
        '<b>Tento uživatel už existuje!</b><br>Přihlaste se vpravo nahoře a prodlužte produkt na profilové stránce.<br>Pokud jste heslo zapomněli, <a href="' +
          window.cnfg_http_aka_tomojectk_base +
          'pass.php?cmd=req">obnovte si ho zde</a>',
      );
      return false;
    }
    if (res.status === 'unknownError') {
      alertCtkApiError();
      return false;
    }
    if (res.error === 'APINotOK') {
      alertCtk(
        'Stránky jsou momentálně nedostupné, zkuste provést akci později nebo nás kontaktujte na e-mailu shop@ctk.cz',
      );
      return false;
    }
    if (res.status === 'ok') {
      // resolve(true);
      const resplatbajson = res.platbajson;
      const parsed = JSON.parse(resplatbajson);
      const crc = parsed.crc;
      delete parsed.crc;
      ajaxPlatebniBranaAkaPost(parsed, crc);
      return true;
    }
    if (res.status === 'notvalid') {
      // resolve(true);
      alertCtk(
        'Objednávku se nepodařilo vytvořit:<br>' + res.validationmessages,
      );
      // const crc = parsed.crc;
      // delete res.crc;
      // ajaxPlatebniBranaAkaPost(res, crc);
      return false;
    }
    // resolve(true);
    // alert('redirekt na platebni branu');
    // return true;

    // const crc = parsed.crc;
    //delete res.crc;
    // ajaxPlatebniBranaAkaPost(res, crc);
    return false;
  };

  const jsondata = JSON.stringify(data);
  console.log('SaveOrder jsondata: ' + jsondata);
  ajaxUniGetAsync('SaveOrderFinish', data, successFunc);
}

export function ajaxSubmitBack() {
  const data: any = {};
  data.company = getValue('company');
  data.name = getValue('name');
  data.surname = getValue('surname');
  data.email = getValue('email');
  data.phone = getValue('phone');
  data.street = getValue('street');
  data.city = getValue('city');
  data.psc = getValue('psc');
  data.country = getValue('country');
  data.ic = getValue('ic');
  data.dic = getValue('dic');
  data.comment = getValue('comment');
  // data.comment = 'text poznamky';
  const successFunc = (result: string) => {
    console.log('save orderback returned');
    const parsed = JSON.parse(result.trim());
    console.log(parsed);
    const res: any = { ...parsed };

    if (res.status === 'unknownError') {
      alertCtkApiError();
      return false;
    }
    if (res.error === 'APINotOK') {
      alertCtk(
        'Stránky jsou momentálně nedostupné, zkuste provést akci později nebo nás kontaktujte na e-mailu shop@ctk.cz',
      );
      return false;
    }
    // alert('redirekt na platebni branu');
    window.location.assign('./kosik.php');
    return true;
  };

  const jsondata = JSON.stringify(data);
  console.log('SaveOrderBack jsondata: ' + jsondata);
  ajaxUniGetAsync('SaveOrderBack', data, successFunc);
}
// export const ajaxSubmitBack = ajaxSubmit;

export function bindHandlers() {
  // fillCountries();
  const vals = [
    'company',
    'name',
    'surname',
    'email',
    'phone',
    'street',
    'city',
    'psc',
    'country',
    'ic',
    'dic',
  ];

  vals.forEach((it) => {
    jQuery('#form' + it).on('change paste keyup', validate);
  });

  jQuery('#formsubmit').on('click', sendOrder);
  jQuery('#formsubmitback').on('click', sendOrderBack);
  jQuery('#filljs').on('click', () => {
    fillValuesJson({
      lengthcode: '6months',
      company: 'soukroma osoba',
      name: 'Petr',
      surname: 'Obornik',
      email: 'obornik@ctk.cz',
      phone: '6066666666',
      street: 'Opletalova 5',
      city: 'Praha',
      psc: '11100',
      country: 'Česká republika',
      ic: '123456789',
      dic: '43211234',
      passwd: '1',
      passwd2: '1',
    });
  });
  jQuery('#goprofile').on('click', (event: any) => {
    window.location.assign('https://www.ctk.cz/mojectk/akaprofile.php');
    event.preventDefault();
    return false;
  });

  jQuery(document).on('click', function (e: any) {
    if (jQuery(e.target).closest('#login-form').length === 0) {
      jQuery('#login-form').removeClass('visible');
    }
  });

  validateSilent();

  jQuery('#sample-img-mail').on('click', function () {
    jQuery('#samples').removeClass('u-hide');
  });

  jQuery('#samples-close').on('click', function () {
    jQuery('#samples').addClass('u-hide');
  });

  jQuery('#clearuserinfobutton').on('click', function () {
    fillEmptyValues();
  });
}
